import { defineComponent as a, createBlock as t, openBlock as n, mergeProps as m, unref as p } from "vue";
import s from "../Divider.vue2.js";
import { useOUIAProps as c } from "../../helpers/ouia.js";
const d = /* @__PURE__ */ a({
  name: "PfNavItemSeparator",
  __name: "NavItemSeparator",
  setup(e) {
    const o = e, r = c({ id: o.ouiaId, safe: o.ouiaSafe });
    return (f, i) => (n(), t(s, m(p(r), { component: "li" }), null, 16));
  }
});
export {
  d as default
};
